import Mixin from '../Mixin';
import FDictionaryCountry from '@/modules/Dictionary/Country/Select';
import FDictionaryCity from '@/modules/Dictionary/City/Select';
import FDictionaryFlight from '@/modules/Dictionary/Flight/Select';
import FDictionaryTariff from '@/modules/Dictionary/Tariff/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  countryTo = new FDictionaryCountry({
    label: 'Страна',
    required: true,
  });

  cityTo = new FDictionaryCity({
    label: 'Город',
    required: true,
  });

  flight = new FDictionaryFlight({
    label: 'Рейс',
  });

  tariff = new FDictionaryTariff({
    label: 'Тариф',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['countryTo', this.countryTo],
      ['cityTo', this.cityTo],
      ['flight', this.flight],
      ['tariff', this.tariff],
    ]);
    this.cityTo.country = this.countryTo;
    this.flight.city = this.city;
    this.flight.cityTo = this.cityTo;
    if (props.value === 10) {
      this.service.set({
        value: 10,
        label: 'ЖД переезд',
      });
    } else {
      this.service.set({
        value: 1,
        label: 'Авиаперелет',
      });
    }
  }


  set(value = {}) {
    super.set(value);
    this.__set('countryTo', value.countryTo, null);
    this.__set('cityTo', value.cityTo, null);
    this.__set('flight', value.flight, null);
    this.__set('tariff', value.tariff, null);
    return this;
  }

  toString() {
    return `${this.city.toString()} - ${this.cityTo.toString()}: ${this.flight.toString()}`;
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = `${this.city.toLabel()} - ${this.cityTo.toLabel()}, ${this.flight.toLabel()}`;
        return data;
      });
  }
}
